import React, { PropTypes } from "react";
import ReactDOM from "react-dom";
import Select from "react-select";
import axios from "axios";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setComponentState, setSidebarState } from "../../actions/Builder.js";
import SidebarSettingAccordion from "./SidebarSettingAccordion.js";

import SidebarElementSpacing from "./SidebarElementSpacing.js";
import LinkPicker from "./LinkPicker.js";
import AlignPicker from "./AlignPicker.js";
import ColorPicker from "./ColorPicker.js";
import BorderPicker from "./BorderPicker.js";
import FontPicker from "./FontPicker.js";

import PaddingPicker from "./PaddingPicker.js";
import SidebarElementWrapper from "./SidebarElementWrapper.js";
import SidebarElementSetting from "./SidebarElementSetting.js";

import SidebarElementHeader from "./SidebarElementHeader.js";

class CrallRecommendationDynamo extends React.Component {
    constructor(props) {
        super(props);
        this.el = this.el.bind(this);
        this.handleBackClick = this.handleBackClick.bind(this);

        this.handleChange = this.handleChange.bind(this);
        this.onButtonChange = this.onButtonChange.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
        this.rows = this.rows.bind(this);
    }

    rows() {
        let ret = [];

        for (let i = 1; i <= this.el().rows; i++) {
            ret.push(
                <tr key={i}>
                    {this.productBox()}
                    {this.productBox()}
                    {this.productBox()}
                </tr>
            );
        }

        return ret;
    }

    onButtonChange(e) {
        this.props.setComponentState(this.el().id, {
            button_text: e.target.value,
        });
    }

    onTextChange(e) {
        this.props.setComponentState(this.el().id, {
            [e.target.getAttribute("data-id")]: e.target.value,
        });
    }

    changeRecommendation = (value) => {
        this.props.setComponentState(this.el().id, {
            recommendation_id: value.id,
        });
    };

    getRecommendations = () => {
        return axios.get("/recommendations?type=email").then((res) => {
            this.props.setComponentState(this.el().id, {
                recommendations: res.data,
            });

            res.data = res.data.map((p) => {
                return p;
            });

            return { options: res.data };
        });
    };

    handleChange(id, s) {
        let changes = {};
        changes[id] = s;
        this.props.setComponentState(this.el().id, changes);
    }

    el() {
        return this.props.builder.components[this.props.id];
    }

    handleBackClick() {
        this.props.setSidebarState({ visible: false });
    }

    componentDidMount() {}

    productBox() {
        return (
            <td style={{ width: "25%", padding: this.el().padding }}>
                <table className="product-box table-block">
                    <tbody>
                        <tr>
                            <td>
                                <img src="https://cdn.crall.io/uploads/test.jpg" />
                            </td>
                        </tr>
                        <tr>
                            <td>Product name</td>
                        </tr>
                        <tr>
                            <td>1.232,-</td>
                        </tr>
                        <tr>
                            <td
                                style={{
                                    padding: "10px",
                                    color: "#fff",
                                    backgroundColor: this.el()
                                        .button_background,
                                }}
                            >
                                {this.el().button_text}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </td>
        );
    }

    render() {
        if (this.props.sidebar == true) {
            return (
                <div className="sidebar text" style={this.props.style}>
                    <SidebarElementHeader
                        handleBackClick={this.handleBackClick}
                        text="Recommendation"
                    />

                    <div
                        className="panel-group panel-group-continuous"
                        id="cart-settings"
                        aria-multiselectable="true"
                        role="tablist"
                    >
                        <SidebarSettingAccordion
                            selectedSetting={false}
                            optionKey="container"
                            parent="cart-settings"
                            title="Container"
                        >
                            <SidebarElementSetting text="Font style">
                                <FontPicker
                                    fontId="text_font"
                                    sizeId="text_size"
                                    colorId="text_color"
                                    font={this.el().text_font}
                                    size={this.el().text_size}
                                    color={this.el().text_color}
                                    handleChange={this.handleChange}
                                />
                            </SidebarElementSetting>
                        </SidebarSettingAccordion>

                        <SidebarSettingAccordion
                            selectedSetting={false}
                            optionKey="container"
                            parent="cart-recommendation"
                            title="Recommendation"
                        >
                            <SidebarElementSetting text="Type">
                                <Select.Async
                                    autoload={true}
                                    valueKey="id"
                                    labelKey="description"
                                    simpleValue={false}
                                    multi={false}
                                    name="form-field-name"
                                    value={this.el().recommendation_id}
                                    loadOptions={this.getRecommendations}
                                    onChange={this.changeRecommendation}
                                />
                            </SidebarElementSetting>

                            <SidebarElementSetting text="Rows">
                                <select
                                    className="form-control"
                                    value={this.el().rows}
                                    data-id="rows"
                                    onChange={this.onTextChange}
                                >
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                </select>
                            </SidebarElementSetting>
                        </SidebarSettingAccordion>

                        <SidebarSettingAccordion
                            selectedSetting={false}
                            optionKey="container"
                            parent="cart-translation"
                            title="Button"
                        >
                            <SidebarElementSetting text="Text">
                                <input
                                    type="text"
                                    value={this.el().button_text}
                                    data-id="button_text"
                                    onChange={this.onTextChange}
                                    className="form-control"
                                />
                            </SidebarElementSetting>

                            <SidebarElementSetting text="Background color">
                                <ColorPicker
                                    id="button_background"
                                    color={this.el().button_background}
                                    handleColorChange={this.handleChange}
                                />
                            </SidebarElementSetting>
                        </SidebarSettingAccordion>
                    </div>
                </div>
            );
        } else {
            return (
                <table
                    className="table-block"
                    style={{
                        width: "100%",
                        fontSize: this.el().text_size,
                        color: this.el().text_color,
                        fontFamily: this.el().text_font,
                    }}
                >
                    <tbody>{this.rows()}</tbody>
                </table>
            );
        }
    }
}
const mapStateToProps = (state) => {
    return {
        builder: state.builder,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ setComponentState, setSidebarState }, dispatch);
};

CrallRecommendationDynamo = connect(
    mapStateToProps,
    mapDispatchToProps
)(CrallRecommendationDynamo);

export default CrallRecommendationDynamo;



// WEBPACK FOOTER //
// ./components/builder/crallrecommendationdynamo.js